import { render } from "./PrimeDataTable.vue?vue&type=template&id=efaf7d88&scoped=true"
import script from "./PrimeDataTable.vue?vue&type=script&lang=js"
export * from "./PrimeDataTable.vue?vue&type=script&lang=js"

import "./PrimeDataTable.vue?vue&type=style&index=0&id=efaf7d88&lang=css"
import "./PrimeDataTable.vue?vue&type=style&index=1&id=efaf7d88&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efaf7d88"]])

export default __exports__